import styled from "styled-components";

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({theme}) => theme.white};
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.16);
  border-radius: 12px;
  padding: 60px 80px;
  h1{
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    letter-spacing: 0.2px;
    color: ${({theme}) => theme.accent};
  }
  p{
    margin-top: 20px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    letter-spacing: 0.3px;
    color: ${({theme}) => theme.grayDark};
  }
  div{
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
